
import React from "react"


const TotalStatus = ({ val }) => {

    // colors //
    const colorDict = {
        'Over' : {
            'fill' : '#E6FEFE',
            'text' : '#039F92',
        },
        'Under' : {
            'fill' : '#fee6ed',
            'text' : '#9f033f',
        },
        'Push' : {
            'fill' : '#e3e3e3',
            'text' : '#7d7d7d',
        },
        'In Progress' : {
            'fill' : '#E8F3FF',
            'text' : '#047EDF',
        }
    }
    

    return (
        <div style={{
            display : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '5px',
            margin: '10px',
            borderRadius: '10px',
            color : colorDict[val]['text'],
            backgroundColor : colorDict[val]['fill'],
            fontSize: '.7rem'
        }}>
            {val}
        </div>
    )
    
}

export default TotalStatus